import { PaymentMethodType } from '@nemuru-eng/js-api-client';
import { createContext, ReactElement, useContext, useReducer } from 'react';

import { CheckoutSessionDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/entities/CheckoutSessionDetailEntity';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { AbstractProcessingStrategyEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/entities/ProcessingStrategy/AbstractProcessingStrategyEntity';

const InitialState = {
  checkoutSessionEntity: undefined as CheckoutSessionDetailEntity | undefined,
  paymentMethodDetailEntities: [] as PaymentMethodDetailEntity[],
  processingStrategyEntity: undefined as AbstractProcessingStrategyEntity | undefined,
  // Selected by the user in the UI
  selectedPaymentMethodType: undefined as PaymentMethodType | undefined,
  refreshing: false,
};

type CheckoutSessionContextInitialState = typeof InitialState;

const reducer = (state: CheckoutSessionContextInitialState, newState: Partial<CheckoutSessionContextInitialState>) => ({
  ...state,
  ...newState,
});

const useSectionReducer = () => {
  const [state, dispatch] = useReducer(reducer, InitialState);

  const update = (newContext: Partial<CheckoutSessionContextInitialState>) => dispatch(newContext);

  return { ...state, update };
};

type CheckoutSessionContextState = ReturnType<typeof useSectionReducer>;

const CheckoutSessionContext = createContext<CheckoutSessionContextState | null>(null);

const CheckoutSessionContextProvider = ({ children }: { children: ReactElement }) => {
  const { ...state } = useSectionReducer();

  return <CheckoutSessionContext.Provider value={state}>{children}</CheckoutSessionContext.Provider>;
};

const useCheckoutSessionContext = (): CheckoutSessionContextState => {
  const context = useContext(CheckoutSessionContext);

  if (!context) {
    throw new Error('useCheckoutSession Context must be used within an CheckoutSessionContextProvider');
  }
  return context;
};

export { CheckoutSessionContextProvider, useCheckoutSessionContext };
